import { supabase } from "@/lib/supabase/supabaseClient";
import { useArchiveSurveyProps } from "./useArchiveSurvey.types";

export const archiveSurvey = async (survey_id: useArchiveSurveyProps) => {
    return await supabase.from('survey').update({archived: true}).eq('id', survey_id).select();
}
